import React from 'react';
import { db } from '../firebase';
import CustomModel from './CustomModel';
export default class VehicleModal extends React.Component {
  constructor() {
    super();
    this.state = {
      amount: 0, key: ''
    }
  }
  render() {
    return (
      <CustomModel
        title="Vehicle Fair Edit"
        show={this.props.show}
        body={this.body()}
        hide={this.props.hide}
      />
    )
  }
  body() {
    return <div className="modal-body">
      <table className="table table-striped table-bordered">
        <tbody>
          <tr>
            <td>
              <ul>
                <li className="row">
                  <div className="col-lg-6"><strong>Vehicle Type</strong></div>
                  <div className="col-lg-6">{this.state.key}</div>
                </li>
                <li className="row">
                  <div className="col-lg-6"><strong>Price Per Mile</strong></div>
                  <div className="col-lg-6"><input value={this.state.amount} step="0.05" type="number" min="0.5" onChange={e => {
                    this.setState({
                      amount: Number(e.target.value)
                    })
                  }} /></div>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <button type="button" className="btn btn-primary" onClick={e => {
        db.updateConfigWithKey("/fairs/" + this.state.key, this.state.amount);
        this.props.hide();
      }}>Edit Price</button>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/modal/VehicleModal.js